import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

import img1 from "./assets/lims-security.webp";
import img2 from "./assets/lims1.jpg";

const images = [img1, img2];

const HeroSection = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative w-full h-[410px] md:h-[510px] overflow-hidden snap-section">

      <AnimatePresence mode="wait">
        <motion.img
          key={index}
          src={images[index]}
          alt="LIMS"
          initial={{ opacity: 0, scale: 1.05 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.7 }}
          className="absolute inset-0 w-full h-full object-cover"
        />
      </AnimatePresence>

      <div className="absolute inset-0 bg-white/60"></div>
      <div className="relative z-10 flex flex-col items-center justify-center h-full px-6 text-center">

        <p className="text-[#FF7A00] font-semibold mb-4 uppercase">
        LIMS Platform
        </p>

        <h1 className="text-2xl md:text-5xl font-bold text-black mb-4 max-w-[800px]">
          Transform Laboratory Operations with{" "}
          <span className="text-[#FF7A00]">
            Smart LIMS
          </span>
        </h1>

        <p className="text-gray-800 mb-6 max-w-[600px]">
          Automate workflows, integrate analyzers, and gain real-time insights
          with a powerful cloud-based Laboratory Information Management System.
        </p>

        <Link to="/contact#ContactForm">
          <button className="bg-[#FF7A00] hover:bg-[#E56700] text-white px-8 py-3 rounded-lg font-semibold shadow-md">
            Contact Us
          </button>
        </Link>

      </div>

      <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex gap-2 z-10">
        {images.map((_, i) => (
          <div
            key={i}
            className={`h-2 w-6 rounded-full transition-all duration-300 ${
              i === index
                ? "bg-[#FF7A00] scale-110"
                : "bg-gray-300"
            }`}
          />
        ))}
      </div>

    </section>
  );
};

export default HeroSection;